import { isDragging, isDraggingAtTheRoot } from "app/stores/documents";
import { SHADOW_ITEM_MARKER_PROPERTY_NAME, TRIGGERS } from "svelte-dnd-action";

export function transformDraggedElement(draggedEl: any, _data: any, _index: number | undefined) {
  draggedEl.style["max-height"] = "32px";
  draggedEl.style["overflow"] = "hidden";
  draggedEl.style["padding-top"] = "0";

  draggedEl.children[0].style["max-height"] = "32px";
  draggedEl.children[0].style["overflow"] = "hidden";
  draggedEl.children[0].children[0].style["margin-top"] = "0";
}

export const isDndPlaceholder = (item: any) => {
  return item[SHADOW_ITEM_MARKER_PROPERTY_NAME];
};

// shared dragging behaviour for the knowledge base navigation
export function handleSharedDraggingBehaviour(e: CustomEvent) {
  // if the user drags an item, we set the isDragging value to true
  if (e.detail.info.trigger === TRIGGERS.DRAG_STARTED) {
    isDragging.set(true);
  }

  // if the user drags an item into the section or outside of any
  // we also reset the isDragging value to false
  // we also reset the hasDraggedEntered to false
  if (
    e.detail.info.trigger === TRIGGERS.DROPPED_INTO_ZONE ||
    e.detail.info.trigger === TRIGGERS.DROPPED_OUTSIDE_OF_ANY
  ) {
    isDragging.set(false);
    isDraggingAtTheRoot.set(false);
  }
}
